import { Component } from '@angular/core';
import {  NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { BuscadorPage } from '../buscador/buscador';
import { OfertaYNoticia } from '../../models/ofertaynoticia.model';
import { NoticiaPage } from '../noticia/noticia';
import { ToastController } from 'ionic-angular';

/**
 * Generated class for the NoticiasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-noticias',
  templateUrl: 'noticias.html',
})
export class NoticiasPage {

  public noticias: Array<OfertaYNoticia>;
  public loader: any;
  public idCategoria: number;
  public idCiudad: number;
  public nombrePueblo: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    private toastCtrl: ToastController,public menuCtrl:MenuController) {

      this.idCategoria = navParams.get("idCategoria");
      this.idCiudad = navParams.get("idCiudad");
      this.nombrePueblo = navParams.get("nombrePueblo") ? navParams.get("nombrePueblo") : "Guía Pueblo";
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad OfertasPage');
  }
  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getNoticias(this.idCiudad,this.idCategoria).subscribe(x=>
          {
            if(!x){
                let toast = this.toastCtrl.create({
                    message: 'No hay noticias en esta categoria',
                    duration: 3000,
                    position: 'bottom'
                  });

                  toast.onDidDismiss(() => {
                    console.log('Dismissed toast');
                  });

                  toast.present();
                  this.navCtrl.pop();
            }
            this.noticias = x;
            this.loader.dismiss();
          },
          error=>{
            console.error(error);
            this.loader.dismiss();
          }
          );
    });
  }
  goToNoticia(noticia){
    this.navCtrl.push(NoticiaPage,{noticia});
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/noticias/noticias.ts